/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext, useRef } from 'react';
import proptypes from 'prop-types';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { dynamicRecsDataModel } from '../dataModel';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';
import DynamicRecs from './DynamicRecs';
import DealsElasticRecs from './DealsElasticRecs';
import {
  getPlaceholderTxtLines,
  extractNValueFromUrl
} from '../utils/helpers';
import { TntWrapper } from '../tnt-recs/TntWrapper';

const { string, bool } = proptypes;

const DynamicRecsWrapperComponent = (props) => {
  const {
    anchor,
    anchorId,
    schemaName,
    showServerSidePlaceholder,
    hideATC,
    isCategoryTab,
    anchorImage,
    zoneName
  } = props;
  const [mounted, setMounted] = useState(false);
  const [tntData, setTntData] = useState(null);
  const { channel } = useContext(ExperienceContext);
  const abcRecsTestEnable = useConfigService('fs:isABCRecsTestEnable');

  const nValue = useRef((typeof window !== 'undefined' && document?.referrer) ? extractNValueFromUrl(document.referrer) : null).current;

  useEffect(() => {
    setMounted(true);
    if (abcRecsTestEnable && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recs.tnt', (data) => {
        let tntObj = {};
        const output = data?.output;
        if (output?.currentAPI === schemaName) {
          if (output?.isDts) {
            tntObj.isDts = output?.isDts;
            tntObj.isTNT = data?.eventName === 'tnt';
            tntObj.schemaName = output?.dtsModel?.model;
            tntObj.dtsModelVariables = output?.dtsModel;
            tntObj.tntTitle = output?.dtsModel?.tntTitle;
            setTntData(tntObj);
          } else {
            tntObj.isDts = output?.isDts;
            tntObj.isTNT = data?.eventName === 'tnt';
            tntObj.schemaName = output?.recsModel?.testAPI;
            tntObj.recsModelVariables = output?.recsModel;
            tntObj.tntTitle = output?.recsModel?.tntTitle;
            setTntData(tntObj);
          }
        }
      });
    }
  }, []);

  if (mounted) {
    if (abcRecsTestEnable && tntData?.isTNT) {
      return (
        <TntWrapper recsprops={{ ...props, nValue }} tntData={tntData} />
      );
    }
    if (schemaName === 'deals_elastic') {
      return (
        <DealsElasticRecs {...props} anchor={anchor || anchorId} />
      );
    }
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <DynamicRecs {...props} nValue={nValue} anchor={anchor || anchorId} />
    );
  }

  if (!mounted && showServerSidePlaceholder) {
    const isMobile = channel === 'mobile';
    const placeholderTxtLines = getPlaceholderTxtLines(isMobile, isCategoryTab, anchorImage, zoneName, hideATC);
    return (
      <LoadingPlaceholder txtPlaceholderLines={placeholderTxtLines} />
    );
  }

  return null;
};

DynamicRecsWrapperComponent.displayName = 'DynamicRecsWrapper';

const propTypes = {
  anchorId: string.isRequired,
  schemaName: string.isRequired,
  anchor: string,
  showServerSidePlaceholder: bool,
  hideATC: bool,
  isCategoryTab: bool,
  anchorImage: string,
  zoneName: string
};
const defaultProps = {
  anchor: null,
  showServerSidePlaceholder: false,
  hideATC: false,
  isCategoryTab: false,
  anchorImage: null,
  zoneName: null
};
const dataModel = dynamicRecsDataModel;

DynamicRecsWrapperComponent.propTypes = propTypes;
DynamicRecsWrapperComponent.defaultProps = defaultProps;
DynamicRecsWrapperComponent.dataModel = dataModel;

const HydratedDynamicRecs = withHydrator({
  delay: 1500,
  placeholder: (<LoadingPlaceholder />),
  preserveCtxVal: 'clientStore'
}, DynamicRecsWrapperComponent);

export const DynamicRecsWrapper = withErrorBoundary(HydratedDynamicRecs);

DynamicRecsWrapper.propTypes = propTypes;
DynamicRecsWrapper.defaultProps = defaultProps;
DynamicRecsWrapper.dataModel = dataModel;
DynamicRecsWrapper.displayName = DynamicRecsWrapperComponent.displayName;
